import React, { useState } from "react";
import { Filters } from "./Filters";
import FloorplanGrid from "./FloorplanGrid";
import { useFloorplanFilters } from "@/hooks/useFloorplanFilters";
import { useFloorplans } from "@/hooks/useFloorplans";
import { useFloorplanConfig } from "@/hooks/useFloorplanConfig";
export var FloorplanContainer = function () {
    var _a, _b;
    var DEFAULT_LABELS = {
        price: "Price Range",
        unit: "Unit Size",
        sqft: "sqft",
    };
    var config = useFloorplanConfig().config;
    var showUnavailableFloorplans = config.showUnavailableFloorplans !== false;
    var _c = useState(false), availableUnitsOnly = _c[0], setAvailableUnitsOnly = _c[1];
    var resetUIState = function () {
        setBedrooms("");
        setBathrooms("");
        setUnitSize({ min: "", max: "" });
        setPriceRange({ min: "", max: "" });
        setAvailableDate(undefined);
        setAvailableUnitsOnly(false);
        setPriceRangeLabel("Price Range");
        setUnitSizeLabel("Unit Size");
        setFloorplanType("");
    };
    var _d = useFloorplanFilters({
        onReset: resetUIState,
    }), filters = _d.filters, setFilter = _d.setFilter, resetFilters = _d.resetFilters;
    var _e = useFloorplans(filters, { availableUnitsOnly: availableUnitsOnly }), data = _e.data, isLoading = _e.isLoading, isError = _e.isError, error = _e.error, fetchNextPage = _e.fetchNextPage, hasNextPage = _e.hasNextPage, isFetchingNextPage = _e.isFetchingNextPage, isFetchNextPageError = _e.isFetchNextPageError;
    var floorplans = (_a = data === null || data === void 0 ? void 0 : data.pages.flatMap(function (page) { return page.floorplans; })) !== null && _a !== void 0 ? _a : [];
    // UI State
    var _f = useState(filters.bedrooms || ""), bedrooms = _f[0], setBedrooms = _f[1];
    var _g = useState(filters.bathrooms || ""), bathrooms = _g[0], setBathrooms = _g[1];
    var _h = useState({
        min: filters.unitSizeMin || "",
        max: filters.unitSizeMax || "",
    }), unitSize = _h[0], setUnitSize = _h[1];
    var _j = useState({
        min: filters.priceMin || "",
        max: filters.priceMax || "",
    }), priceRange = _j[0], setPriceRange = _j[1];
    var _k = useState(DEFAULT_LABELS.price), priceRangeLabel = _k[0], setPriceRangeLabel = _k[1];
    var _l = useState(DEFAULT_LABELS.unit), unitSizeLabel = _l[0], setUnitSizeLabel = _l[1];
    var _m = useState(filters.availableDate ? new Date(filters.availableDate) : undefined), availableDate = _m[0], setAvailableDate = _m[1];
    var _o = useState(filters.floorplanType || ""), floorplanType = _o[0], setFloorplanType = _o[1];
    var handleReset = function () {
        resetFilters();
        resetUIState();
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Filters, { uiState: {
                bedrooms: bedrooms,
                bathrooms: bathrooms,
                unitSize: unitSize,
                priceRange: priceRange,
                availableDate: availableDate,
                availableUnitsOnly: availableUnitsOnly,
                priceRangeLabel: priceRangeLabel,
                unitSizeLabel: unitSizeLabel,
                floorplanType: floorplanType,
            }, setters: {
                setBedrooms: setBedrooms,
                setBathrooms: setBathrooms,
                setUnitSize: setUnitSize,
                setPriceRange: setPriceRange,
                setAvailableDate: setAvailableDate,
                setAvailableUnitsOnly: setAvailableUnitsOnly,
                setPriceRangeLabel: setPriceRangeLabel,
                setUnitSizeLabel: setUnitSizeLabel,
                setFloorplanType: setFloorplanType,
            }, filters: filters, setFilter: setFilter, onReset: handleReset, labels: DEFAULT_LABELS, bedroomTypes: config.bedroomTypes, numberOfBathrooms: config.bathroomCount, floorplanTypes: config.floorplanTypes, showUnavailableFloorplans: showUnavailableFloorplans }),
        React.createElement(FloorplanGrid, { onReset: handleReset, hasNextPage: hasNextPage, fetchNextPage: fetchNextPage, isFetchingNextPage: isFetchingNextPage, isFetchNextPageError: isFetchNextPageError, floorplans: floorplans, error: error, isError: isError, isLoading: isLoading, costEstimatorPropertyId: (_b = config.costEstimatorPropertyId) !== null && _b !== void 0 ? _b : "" })));
};
